import { PercentInput } from "@akuna/ui";
import { cn } from "@/lib/utils";
import { parsePercent } from "@/lib/commissions/tree";

type Props = {
  label: string;
  value: number | null;
  /** Called on blur when the typed value differs from `value` ("" → null). */
  onCommit: (percent: number | null) => void;
  highlighted?: boolean;
  placeholder?: string;
};

/** A percent field that saves when the person leaves it, like the rest of the commission screens. */
export function PercentCell({ label, value, onCommit, highlighted = false, placeholder }: Props) {
  return (
    <PercentInput
      className={cn("w-28 shrink-0", highlighted && "rounded-md ring-2 ring-primary")}
      aria-label={label}
      placeholder={placeholder}
      value={value ?? undefined}
      onBlur={(e) => {
        const next = parsePercent(e.currentTarget.value);
        if (next !== null && !Number.isFinite(next)) return;
        if (next === value) return;
        onCommit(next);
      }}
    />
  );
}
